var _excluded = ["tooltip", "error", "withIcon", "label", "onDrop", "disabled", "extension"],
  _excluded2 = ["ref"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Grid, Form, Ref, Tooltip, Segment, Icon } from "../..";
import { getExtensionIcon } from "../../utils";
import "./dropzone.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Dropzone = function Dropzone(_ref) {
  var _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? {} : _ref$tooltip,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? false : _ref$withIcon,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$onDrop = _ref.onDrop,
    onDrop = _ref$onDrop === void 0 ? null : _ref$onDrop,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$extension = _ref.extension,
    extension = _ref$extension === void 0 ? null : _ref$extension,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var handleUpload = function handleUpload(acceptedFiles) {
    if (onDrop) {
      onDrop(acceptedFiles);
    }
  };
  var renderIcon = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Icon, {
      name: getExtensionIcon(extension),
      size: "mini",
      style: {
        fontSize: '4em'
      }
    });
  }, [extension]);
  var renderField = function renderField(rootProps, getInputProps) {
    return /*#__PURE__*/_jsxs(Form.Field, {
      children: [label && /*#__PURE__*/_jsx("label", {
        children: "Document"
      }), /*#__PURE__*/_jsxs(Segment, Object.assign({}, rootProps, {
        className: error ? 'error' : null,
        disabled: disabled,
        children: [/*#__PURE__*/_jsx("input", Object.assign({}, getInputProps())), /*#__PURE__*/_jsx("p", {
          children: "Glisser/d\xE9poser un fichier ou cliquer"
        })]
      }))]
    });
  };
  renderField.handledProps = [];
  return /*#__PURE__*/_jsx(ReactDropzone, Object.assign({
    multiple: false,
    error: true,
    onDrop: withIcon ? handleUpload : onDrop,
    disabled: disabled
  }, rest, {
    children: function children(_ref2) {
      var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps;
      var _getRootProps = getRootProps(),
        ref = _getRootProps.ref,
        rootProps = _objectWithoutPropertiesLoose(_getRootProps, _excluded2);
      return /*#__PURE__*/_jsx(Grid, {
        className: "dropzone",
        children: /*#__PURE__*/_jsxs(Grid.Row, {
          columns: 2,
          children: [/*#__PURE__*/_jsx(Grid.Column, {
            width: withIcon ? 13 : 16,
            children: /*#__PURE__*/_jsx(Ref, {
              innerRef: ref,
              children: tooltip ? /*#__PURE__*/_jsx(Tooltip, Object.assign({
                trigger: renderField(rootProps, getInputProps)
              }, tooltip)) : renderField(rootProps, getInputProps)
            })
          }), withIcon && /*#__PURE__*/_jsx(Grid.Column, {
            width: 3,
            verticalAlign: "bottom",
            children: renderIcon
          })]
        })
      });
    }
  }));
};
Dropzone.handledProps = ["disabled", "error", "extension", "label", "onDrop", "tooltip", "withIcon"];
Dropzone.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tooltip: PropTypes.object,
  error: PropTypes.bool,
  withIcon: PropTypes.bool,
  label: PropTypes.string,
  onDrop: PropTypes.func,
  disabled: PropTypes.bool,
  extension: PropTypes.string
};
export default Dropzone;